import React, { useState } from 'react';
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Button, CircularProgress, Box ,Typography } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL;

const PromedioRPMDiarioTable = () => {
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [fechas, setFechas] = useState(() => {
    const stored = localStorage.getItem('tablaRPMFechas');
    return stored ? JSON.parse(stored) : [];
  });
  const [maquinas, setMaquinas] = useState(() => {
    const stored = localStorage.getItem('tablaRPMMaquinas');
    return stored ? JSON.parse(stored) : [];
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await fetch(`${API_URL}/api/promedio-rpm-diario`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fechaInicio, fechaFin })
    });
    const data = await response.json();
    setFechas(data.fechas);
    setMaquinas(data.maquinas);
    localStorage.setItem('tablaRPMFechas', JSON.stringify(data.fechas));
    localStorage.setItem('tablaRPMMaquinas', JSON.stringify(data.maquinas));
    setLoading(false);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Paper sx={{ p: 2 }}>
         <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#999', fontFamily: 'Roboto' }}>
        Promedio de Revoluciones
      </Typography>
        <form onSubmit={handleSubmit} style={{ marginBottom: 24 }}>
          <TextField
            label="Fecha inicio"
            type="date"
            value={fechaInicio}
            onChange={e => setFechaInicio(e.target.value)}
            InputLabelProps={{ shrink: true }}
            required
            sx={{
              mr: 2,
              '& .MuiInputBase-root': {
                backgroundColor: '#302f2fff'
              }
            }}
          />
          <TextField
            label="Fecha fin"
            type="date"
            value={fechaFin}
            onChange={e => setFechaFin(e.target.value)}
            InputLabelProps={{ shrink: true }}
            required
            sx={{
              mr: 2,
              '& .MuiInputBase-root': {
                backgroundColor: '#302f2fff'
              }
            }}
          />
          <Button type="submit" variant="contained">Consultar</Button>
        </form>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          fechas.length > 0 && maquinas.length > 0 && (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Fecha</TableCell>
                    {maquinas.map(m => (
                      <TableCell key={m.maquinaId} sx={{ fontWeight: 'bold' }}>{m.maquinaId}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fechas.map(fecha => (
                    <TableRow key={fecha}>
                      <TableCell>{fecha}</TableCell>
                      {maquinas.map(m => (
                        <TableCell key={m.maquinaId}>
                          {m.dias[fecha] !== null ? m.dias[fecha] : '-'}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}
      </Paper>
    </Container>
  );
};

export default PromedioRPMDiarioTable;